import { render, staticRenderFns } from "./InvoiceManageDetail2.vue?vue&type=template&id=0ae6ae03&scoped=true"
import script from "./InvoiceManageDetail2.vue?vue&type=script&lang=js"
export * from "./InvoiceManageDetail2.vue?vue&type=script&lang=js"
import style0 from "./InvoiceManageDetail2.vue?vue&type=style&index=0&id=0ae6ae03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6ae03",
  null
  
)

export default component.exports